import { SeoLandingTemplate } from "@/components/seo/seo-landing-template";
import {
	AI_TEAMMATES_MARKETING_SEO_EXTERNAL_LINKS,
	AI_TEAMMATES_MARKETING_SEO_FAQ_ITEMS,
	AI_TEAMMATES_MARKETING_SEO_H1,
	AI_TEAMMATES_MARKETING_SEO_INTERNAL_LINKS,
	AI_TEAMMATES_MARKETING_SEO_INTRO_PARAGRAPHS,
	AI_TEAMMATES_MARKETING_SEO_OUTLINE,
	AI_TEAMMATES_MARKETING_SEO_SECTIONS,
} from "@/constants/seo/ai-teammates-marketing-seo-content";
import { AI_TEAMMATES_MARKETING_SEO_LANDING_UI } from "@/constants/seo/seo-landing-ui";

export function AiTeammatesMarketingSeoPage() {
	return (
		<SeoLandingTemplate
			ui={AI_TEAMMATES_MARKETING_SEO_LANDING_UI}
			h1={AI_TEAMMATES_MARKETING_SEO_H1}
			introParagraphs={AI_TEAMMATES_MARKETING_SEO_INTRO_PARAGRAPHS}
			outline={AI_TEAMMATES_MARKETING_SEO_OUTLINE}
			sections={AI_TEAMMATES_MARKETING_SEO_SECTIONS}
			internalLinks={AI_TEAMMATES_MARKETING_SEO_INTERNAL_LINKS}
			externalLinks={AI_TEAMMATES_MARKETING_SEO_EXTERNAL_LINKS}
			faqItems={AI_TEAMMATES_MARKETING_SEO_FAQ_ITEMS}
		/>
	);
}
